// extracted by mini-css-extract-plugin
module.exports = {"ad-box":"ad-box_ad-box__XJiQ2","ad-rect":"ad-box_ad-rect__OYW88","ad-banner":"ad-box_ad-banner__hvgEc","ad-rail":"ad-box_ad-rail__hGEqa"};